// extracted by mini-css-extract-plugin
module.exports = {"title":"page_nav_layout-module__title--3UC7s","content":"page_nav_layout-module__content--5KM1a","footer":"page_nav_layout-module__footer--2Fe2D"};